




import { Component } from "vue-property-decorator";

import AppVue from "@/AppVue.vue";
import AuthenticationInProgressCpt from "./AuthenticationInProgressCpt.vue";

@Component({
  components: {
    AuthenticationInProgressCpt,
  },
})
export default class AuthenticateView extends AppVue {}
